import React from 'react'
import styles from './officeHelper.scss'
import CreatableSelect from 'react-select/lib/Creatable'
import ReactSelect2, {components as reactSelectComponents} from 'react-select'
import cs from 'classnames'
import i18n from 'lib/i18n'

const _ = i18n('dswizard')

let selectInFocusWithin = false
/**
 * Customization object for the react-select using the same style like other components on tha site.
 */
export const customCreatableSelectStyles = {
    control: (base, state) => {
        selectInFocusWithin = state.isFocused
        return {
        ...base,
        flex: "4",
        fontSize: "12px",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "flex-end",
        color: "black",
        backgroundColor: state.isDisabled ? "#f9f9f9" : "#fff",
        borderColor: "#d9d9d9 #ccc #b3b3b3",
        borderRadius: "2px",
        border: "1px solid #d9d9d9",
        minHeight: "25px",
        maxHeight: "auto",
        //height: state.isFocused ? "auto" : "25px",
        boxShadow: state.isFocused ? null : null,
        "&:hover": {
          borderColor: "#d9d9d9 #ccc #b3b3b3"
        },
        "&:focus": {
          borderColor: "#d9d9d9 #ccc #b3b3b3"
        },
        padding: 0,
        margin: 0,
        overflow: state.isFocused ? null : "hidden"
      }},
      menu: base => ({
        ...base,
        borderRadius: 2,
        hyphens: "auto",
        marginTop: 0,
        textAlign: "left",
        wordWrap: "break-word",
        color: "black",
      }),
      menuList: base => ({
        ...base,
        padding: 0,
        verticalAlign: "baseline",
        color: "black",
      }),
      singleValue: (base, state) => ({
        ...base,
        minHeight: "16px",
        lineHeight: "14px",
        color: "black",
      }),
      multiValue: (base, state) => ({
        ...base,
        minHeight: "16px",
        lineHeight: "14px",
        maxHeight: "18px",
        border: "0.5px solid #003366",
        background: '#003366',
        color: "black",
        div: {
            color: "black",
            fontSize: '1.2em',
            lineHeight: '0.8em'
        }
      }),
      /* noOptionsMessage: (base, state) => ({
        ...base,
        padding: 0,
        height: "20px",
        lineHeight: "16px"
      }), */
      option: (base, state) => ({
        ...base,
        padding: 0,
        fontSize: '1em',
        maxHeight: "25px",
        //color: "black"
      }),
      valueContainer: (base, state) => ({
        ...base,
        padding: 0,
        margin: 0,
        top: 0
      }),
      multiValueRemove: (base, state) => ({
        ...base,
        display: state.isDisabled ? "none" : null,
        padding: 0
      }),
      clearIndicator: (base, state) => ({
        ...base,
        padding: 0
      }),
      dropdownIndicator: (base, state) => ({
        ...base,
        marginTop: 0,
        padding: 0
      }),
      indicatorsContainer: (base, state) => ({
        ...base,
        padding: 0,
        margin: 0,
        height: "23px",
        top: 0
      }),
      indicatorSeparator: (base, state) => ({
        ...base,
        padding: 0,
        margin: 0,
        height: "0",
        top: 0
      }),
      group: (base, state) => ({
        ...base,
        padding: 0,
        margin: 0,
        height: "20px",
        top: 0
      }),
      groupHeading: (base, state) => ({
        ...base,
        padding: 0,
        margin: 0,
        height: "20px",
        top: 0
      }),
      input: (base, state) => ({
        ...base,
        padding: 0,
        margin: "2px 0 0 0",
        height: "20px",
        top: 0,
        fontSize: '1.2em',
        lineHeight: '0.8em',
        width: selectInFocusWithin ? '100%!important' : 'auto',
        div: {
            width: selectInFocusWithin ? '100%!important' : 'auto',
            input: {
                width: selectInFocusWithin ? '100%!important' : 'auto',
            },
        }
      }),
      noOptionsMessage: (base, state) => ({
        ...base,
        padding: 0,
        margin: 0,
        height: "20px",
        fontSize: '1em'
      }),
      placeholder: (base, state) => ({
        ...base,
        fontSize: '1.1em',
        lineHeight: '1.1em'
      })
}

/**
 * Custom dropdown indicator for react-select to be the similar style lik other elements on the page
 * @param {object} props
 */
export const DropdownIndicator = (props) => {
    return reactSelectComponents.DropdownIndicator && (
      <reactSelectComponents.DropdownIndicator {...props}>
        <span className={styles.downArrowHolder}>
                <span className={styles.downArrow}></span>
        </span>
      </reactSelectComponents.DropdownIndicator>
    )
}

/**
 * Custom dropdown indicator for react-select to be the similar style lik other elements on the page
 * @param {object} props
 */
export const NoOptionsMessage = (props) => {
    return reactSelectComponents.DropdownIndicator && (
      <reactSelectComponents.NoOptionsMessage {...props}>
        {_('noOptions')}
      </reactSelectComponents.NoOptionsMessage>
    )
}

const getDeleteIcon = () => {
    try {
        return require(`resources/images/a-trash_1x_ovbBlue.svg`)
    } catch(err) {
        return require(`resources/images/icn-no-result.svg`)
    }
}

/**
 *
 * @param {*} props
 */
const SelectRemovableOption = props => {
    return (
        <div className={styles.creatableOptionContainer}>
        <reactSelectComponents.Option {...props} className={styles.creatableOptionItem}/>
            {props.data.isRecent ?
                <span>
                    <button type="button" className={styles.creatableOptionItem} onClick={event => {
                        event.preventDefault()
                        props.delete(props.value)
                    }}>
                        <img src={getDeleteIcon()}/>
                    </button>
                </span>
                : null
            }
        </div>
    )
}

/**
 * This is a custom MultiValueRemove for react select to be able set a separate unremovable value in dropdown
 * but the rest is still dynamic
 * @param {object} props
 */
const MultiValueRemove = props => {
    return (
        <reactSelectComponents.MultiValueRemove {...props}>
            {!props.data.isPermanentSelected ? props.children : null}
        </reactSelectComponents.MultiValueRemove>
    )
}

const ValueContainer = ({ children, ...props }) => {
    return (<reactSelectComponents.ValueContainer {...props} className={styles.selectValueContainer}>
        <div className={styles.composeRecipients}>
            {children}
        </div>
    </reactSelectComponents.ValueContainer>)
}

/**
 * To validate the inserting value you can use this property for CreatableSelect
 */
export default class CustomSelect extends React.Component {
	static propTypes = {
        formatCreateLabel: React.PropTypes.string,
        customClassName: React.PropTypes.string,
        handleOnBlur: React.PropTypes.func,
        setDeleteItemByOption: React.PropTypes.func,
        showExtraButton: React.PropTypes.bool,
        onClickExtraButton: React.PropTypes.func,
    }

    static defaultProps = {
        isCreatableSelect: false
    }

    constructor(props) {
		super(props)
    }

    /**
     * Must handle on blur because else loose values. ()
     * @param {*} event
     */
    handleOnBlur(event){
        const {onChange} = this.props
        onChange({label: event.target.value, value: event.target.value})
        return newValue
    }

    render() {
        const {handleOnBlur, customClassName, showExtraButton, onClickExtraButton, setDeleteItemByOption} = this.props
        // placeholder={_('searchPromptText')}
        return (
        <ReactSelect2
            {...this.props}
            onBlur={
                (e)=> {
                    if (handleOnBlur) {
                        handleOnBlur(e)
                    } else {
                        this.handleOnBlur(e)
                    }
                }
            }
            openMenuOnFocus={true}
            placeholder={''}
            onBlurResetsInput={false}
            isSearchable
            styles={customCreatableSelectStyles}
            components={{
                DropdownIndicator,
                NoOptionsMessage,
                Option: (p) => (SelectRemovableOption({...p, delete: setDeleteItemByOption})),
                MultiValueRemove,
                ValueContainer
            }}
            className={customClassName}
            showExtraButton={showExtraButton && !isDisabled}
            onClickExtraButton={onClickExtraButton}
        />)
    }
}



// WEBPACK FOOTER //
// ./components/office/officeHelper.jsx